import $ from 'jquery';
import 'jquery.maskedinput/src/jquery.maskedinput';
import axios from "axios";
import { validateUploadedFile } from "../contractors.js";

document.addEventListener('DOMContentLoaded', function() {
    var taxIdElement = document.querySelector('#tax_id');

    if (taxIdElement) {
        new Cleave('#tax_id', {
            delimiters: ['-'],
            blocks: [2, 7],
            numericOnly: true,
        });
    }
    w9DragDrop();
    companyLogoDragDrop();
});

export const companyLogoDragDrop = function () {
    let companyLogo = $('#company-logo-upload')
    draggableElement(companyLogo)
    companyLogo.on('drop', function (e) {
        let files = e.originalEvent.dataTransfer.files;
        if (files.length > 1) {
            $("#error-modal").modal('show')
            document.getElementById('error-title').innerHTML = 'File limit exceeded'
            document.getElementById('error-body').innerHTML = 'You can only upload one file'
            return false
        }
        uploadCompanyLogo(files[0])
    });
}

export const uploadCompanyLogo = function (file, event=null) {
    if (validatePocLogo(file, file['name'], event)) {
        let formData = new FormData();
        formData.append("company_logo", file);
        formData.append("_token", $('meta[name="csrf-token"]').attr('content'));
        axios.post('/broker/poc/company_logo', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(function (resp) {
            document.getElementById('logo-file-name').innerHTML = '' +
                '<a class="color-blue" ' +
                'href="' + resp.data.url + '" ' +
                'target="_blank">' + resp.data.file_name + '</a>'
            document.getElementById('logo').value = resp.data.path
        })
    }
}

export const w9DragDrop = function () {
    let w9 = $('#w9-upload')
    draggableElement(w9)
    w9.on('drop', function (e) {
        let files = e.originalEvent.dataTransfer.files;
        if (files.length > 1) {
            $("#error-modal").modal('show')
            document.getElementById('error-title').innerHTML = 'File limit exceeded'
            document.getElementById('error-body').innerHTML = 'You can only upload one file'
            return false
        }
        uploadW9File(files[0])
    });
}


export const draggableElement = function (element) {
    element.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
    })
}

export const uploadW9File = function (file, event = null) {
    console.log(`uploadW9File event: `, event);
    console.log(`uploadW9File file: `, file);
    if (file && typeof file.name === 'string') {
        if (validateUploadedFile(file, file['name'], event)) {
            let formData = new FormData();
            formData.append("w9", file);
            formData.append("_token", $('meta[name="csrf-token"]').attr('content'));
            axios.post('/broker/poc/w9', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (resp) {
                document.getElementById('w9-file-name').innerHTML = '' +
                    '<a class="color-blue" ' +
                    'href="' + resp.data.url + '" ' +
                    'target="_blank">' + resp.data.file_name + '</a>'
                document.getElementById('w9').value = resp.data.path
            })
        }
    } else {
        console.log("unable to process file: ", file);
    }
}

export const loadW9 = function (event) {
    let file = event.target.files[0]
    uploadW9File(file, event)
}

export const validatePocLogo = function (file, file_name, event) {
    let size = file['size'] / (1024 * 1024)
    let splitted_name = file_name.split('.')
    let extension = splitted_name[splitted_name.length - 1].toLowerCase()
    let error_modal_element = document.getElementById('error-modal')
    if (size > 2) {
        if (error_modal_element) {
            $("#error-modal").modal('show')
            document.getElementById('error-title').innerHTML = 'File Size Error'
            document.getElementById('error-body').innerHTML = 'File size must be less than 2 MB'
        }
        if (event)
            event.target.value = ""
        return false
    } else if (extension !== 'jpg' && extension !== 'png') {
        if (error_modal_element) {
            $("#error-modal").modal('show')
            document.getElementById('error-title').innerHTML = 'File Extension Error'
            document.getElementById('error-body').innerHTML = 'File type not accepted, only png and jpg files are allowed'
        }
        if (event)
            event.target.value = ""
        return false
    }
    return true
}

export const loadPocLogo = function (event) {
    let file = event.target.files[0]
    uploadCompanyLogo(file,event)
}

export const submitPocForm = function () {
    if (validatePocForm()) {
        document.getElementById("poc-details-form").submit();
    }
}

export const getNumericTaxId = function(id){
    id = id.replace('(','')
    id = id.replace(')','')
    id = id.replace('-','')
    return id
}

export const validatePocForm = function () {

    if (getNumericTaxId(document.getElementById('tax_id').value).length !== 9) {
        $("#error-modal").modal('show')
        document.getElementById('error-title').innerHTML = 'Invalid EIN'
        document.getElementById('error-body').innerHTML = 'Your Employer Identification Number (EIN) is invalid'
        return false
    }

    return true
}

// this makes the functions exported for use by blade template JS scripts and is used by webpack
export const brokerPocModule = {
    loadW9,
    loadPocLogo,
}